class DuiPageGuardManager {
  constructor() {
    this._isGuarding = false;

    this._boundFns = {
      windowBeforeUnload: this.windowBeforeUnloadPerformed.bind(this),
    };
  }

  guard() {
    if (this._isGuarding) {
      return;
    }

    this.addEventListeners();
    this._isGuarding = true;
  }

  unguard() {
    if (!this._isGuarding) {
      return;
    }

    this.removeEventListeners();
    this._isGuarding = false;
  }

  // Events
  addEventListeners() {
    window.addEventListener('beforeunload', this._boundFns.windowBeforeUnload);
  }

  removeEventListeners() {
    window.removeEventListener('beforeunload', this._boundFns.windowBeforeUnload);
  }

  windowBeforeUnloadPerformed(ev) {
    ev.preventDefault();
    ev.returnValue = '';
  }
  // END Events
}


export default {
  install: function(Vue, options) {
    Vue.duiPageGuardManager = new DuiPageGuardManager();
  },
};
